import "./location.css";

const LocationDocument = () => {
  return (
    <div className="left-side-location-document">
      <h4>Location Folder</h4>{" "}
    </div>
  );
};

export default LocationDocument;
